import * as API from 'common/constant/routes'
import { getJson, postJson } from 'helper/http'

export const isLoggedIn = () => getJson(API.IS_LOGGED_IN)
export const isLoggedInPlcp = () => getJson(API.IS_LOGGED_IN_PLCP)

export const login = (loginDetails) => postJson(API.AUTH_LOGIN, {}, loginDetails)
export const loginPlcp = (loginDetails) => postJson(API.AUTH_LOGIN_PLCP, {}, loginDetails)

export const qlikAuth = (loginDetails) => postJson(API.QLIK_AUTH, {}, loginDetails)
export const qlikAuthPlcp = (loginDetails) => postJson(API.QLIK_AUTH_PLCP, {}, loginDetails)

export const logout = () => getJson(API.AUTH_LOGOUT)
export const logoutPlcp = () => getJson(API.AUTH_LOGOUT_PLCP)

export const authQlik = () => getJson(API.AUTH_QLIK, {}, { mp: true })
